import { api } from "../client";
import { DocumentOfferQuestionChangelog } from "../schema/DocumentOfferQuestionChangelog";
import { Config } from "../types";

type ApiRequestConfig = Config<DocumentOfferQuestionChangelog[]>;

export const getDocumentOfferQuestionChangelog = async (
  documentOfferQuestionId: number,
  config?: ApiRequestConfig
) => {
  return api.get<DocumentOfferQuestionChangelog[]>(
    `document_offer_questions/${documentOfferQuestionId}/document_offer_question_histories`,
    config
  );
};
